import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
  createRuleConfiguration,
  createV2RuleConfiguration,
  getFilterTemplateById,
  getFilterTemplates,
  getRuleConfiguration,
  getRuleConfigurations,
  getV2RuleConfiguration,
  listRuleConfigurationFilters,
  listRuleConfigurations,
  updateRuleConfiguration,
  updateRuleConfigurationScope,
  updateV2RuleConfiguration,
} from "./actions";

export const ruleConfigurationEntityAdapter = createEntityAdapter({
  selectId: (rule) => rule.ruleId,
});

const initialState = ruleConfigurationEntityAdapter.getInitialState({
  totalCount: 0,
  modals: {},
  filters: [],
  filterTemplates: [],
  executionTimedOut: false,
  count: 0,
});

export const ruleConfigurationSlice = createSlice({
  name: "ruleConfiguration",
  initialState: initialState,
  reducers: {
    showRuleConfigurationDeleteModal: (state, action) => {
      state.modals.ruleConfigurationDeleteModal = action.payload;
    },
    showRuleConfigurationDuplicateModal: (state, action) => {
      state.modals.ruleConfigurationDuplicateModal = action.payload;
    },
    showRuleConfigurationManualTriggerModal: (state, action) => {
      state.modals.ruleConfigurationManualTriggerModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRuleConfigurations.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.setAll(state, action.payload?.data?.rules);
        state.totalCount = action.payload?.data?.totalCount;
      } else {
        state.ids = [];
        state.totalCount = 0;
      }
    });
    builder.addCase(getRuleConfiguration.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.upsertOne(state, action.payload?.rule);
      }
    });
    builder.addCase(updateRuleConfiguration.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.upsertOne(state, action.payload?.rule);
      }
    });
    builder.addCase(createRuleConfiguration.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.upsertOne(state, { ...action.payload?.rule, scope: action.payload?.ruleScope });
      }
    });
    builder.addCase(listRuleConfigurations.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.setAll(state, action.payload?.data?.rules);
        state.totalCount = action.payload?.data?.totalCount;
        state.count = action.payload?.data?.count;
        state.executionTimedOut = action.payload?.data?.executionTimedOut;
      } else {
        state.ids = [];
        state.totalCount = 0;
        state.executionTimedOut = false;
      }
    });
    builder.addCase(listRuleConfigurationFilters.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        state.filters = action.payload?.filters;
      } else {
        state.filters = [];
      }
    });
    builder.addCase(getV2RuleConfiguration.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.upsertOne(state, action.payload?.rule);
      }
    });
    builder.addCase(updateV2RuleConfiguration.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.upsertOne(state, action.payload?.rule);
      }
    });
    builder.addCase(createV2RuleConfiguration.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        ruleConfigurationEntityAdapter.upsertOne(state, {
          ...action.payload?.rule,
        });
      }
    });
    builder.addCase(getFilterTemplates.fulfilled, (state, action) => {
      state.filterTemplates = action?.payload?.data?.templates;
      state.count = action?.payload?.data?.templates?.length;
    });
    builder.addCase(updateRuleConfigurationScope.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        const ruleId = action.payload?.scope?.ruleId;
        if (ruleId && state.entities[ruleId]) {
          const updatedRule = {
            ...state.entities[ruleId],
            scope: action.payload?.scope,
          };

          ruleConfigurationEntityAdapter.upsertOne(state, updatedRule);
        }
      }
    });
    builder.addCase(getFilterTemplateById.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        state.filterTemplates = [action?.payload?.template];
        state.count = action?.payload?.template?.length;
      }
    });
  },
});

export const {
  showRuleConfigurationDeleteModal,
  showRuleConfigurationDuplicateModal,
  showRuleConfigurationManualTriggerModal,
} = ruleConfigurationSlice.actions;

export default ruleConfigurationSlice.reducer;
